import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import PageHeader from "../components/pageHeader";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import debounce from 'lodash.debounce';

const Styles = () => {

    const navigate = useNavigate();
    const [dataStyle, setDataStyle] = useState([]);

    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');

    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetStyleDetailsAll', setDataStyle);

    }, [dataStyle]);

    // Filter Data based on searchQuery
    useEffect(() => {
        const lowercasedFilter = searchQuery.toLowerCase();
        const filtered = dataStyle.filter(item =>
            item.style.toLowerCase().includes(lowercasedFilter) ||
            item.description.toLowerCase().includes(lowercasedFilter) ||
            item.id.toString().toLowerCase().includes(lowercasedFilter)
        );
        setFilteredData(filtered);
    }, [searchQuery, dataStyle]);
        
        
    // Debounced search handler to avoid excessive re-renders
    const handleSearchChange = debounce((e) => {
        setSearchQuery(e.target.value);
    }, 300);

    // Highlight the matching text
    const highlightText = (text, query) => {
        if (!query) return text;

        const parts = text.split(new RegExp(`(${query})`, "gi"));
        return parts.map((part, index) => 
            part.toLowerCase() === query.toLowerCase() ? (
                <span key={index} style={{ backgroundColor: "yellow" }}>
                    {part}
                </span>
            ) : (
                part
            )
        );
    };

    const columns = [
        {
            name: "Style",
            //selector: row => row.style,
            selector: row => (
                <div>{highlightText(row.style, searchQuery)}</div>
            ),
            sortable: true,
            width: "200px"
        },
        {
            name: "Description",
            selector: row => row.description,
            cell: (row) => (
                <div style={{ whiteSpace: "pre-line", width: "1350px" }} dangerouslySetInnerHTML={{ __html:row.description }} />
                //<div style={{ whiteSpace: "pre-line", width: "1350px" }} dangerouslySetInnerHTML={{ __html: highlightText(row.description, searchQuery) }} />
            ),
            
            allowOverflow: true,
            maxWidth: "600px",
        },
        {
            name: "Action",
            cell: (row) => (
                <div>
                    <Link to={``} onClick={() => onStatusClick(row.id, row.style)}>
                        <img
                            src={row.status === 1 ? "/images/ImgActive.gif" : "/images/ImgInActive.gif"}
                            alt="Change Status"
                            title="Change Status"
                            style={{ width: "50px", height: "25px" }}
                        />
                    </Link>

                    {' '} {' '}{' '} {' '}{' '} {' '}{' '} {' '}
                    <Link to={``} onClick={(event) => onEditClick(event, row.id)}>
                        <img
                            src="/images/ImgEdit.ico" // Set the correct image source
                            alt="Edit"
                            title="Edit"
                            style={{ width: "30px", height: "30px" }}
                        />
                    </Link>
                </div>
            ),
            maxWidth: "200px",

        },
    ];

    const onStatusClick = async (id, style) => {

        const confirmed = window.confirm("Are you sure you want to change " + style + " Style status?");
        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        try {

            const response = await fetch('https://igapi.heuristticminds.com/api/SubjectStyleList/Update-ChangeStyleStatus?id=' + id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {

            }
        }
        catch {
        }
    };

    const onEditClick = async (event, id) => {

        event.preventDefault(); // Prevents the default behavior of the link
        navigate(`/addStyles/${id}`);
    }


    return (
        <>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">

                    <PageHeader name='Art Style' icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4">
                                    <div className="card-header">Art Style Details</div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <a href="/addStyles" className="btn btn-primary"><i className="bi bi-plus-circle-fill"></i> Add Styles</a>
                                                </div>
                                                <div className="col-lg-9">

                                                </div>
                                                <div className="col-lg-3">
                                                    <input type="text" name="search" onChange={handleSearchChange} className="form-control" placeholder="Text Search" />
                                                </div>  
                                            </div>
                                        <div className="pb-2">
                                            <div className="ps-2 pe-2">
                                                <DataTable
                                                    columns={columns}
                                                    data={filteredData}
                                                    pagination
                                                />
                                            </div>
                                        </div>

                                        
                                    </div>




                                </div>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
};
export default Styles



